import { render, staticRenderFns } from "./dataGridTab.vue?vue&type=template&id=05f0c394&scoped=true"
import script from "./dataGridTab.vue?vue&type=script&lang=js"
export * from "./dataGridTab.vue?vue&type=script&lang=js"
import style0 from "./dataGridTab.vue?vue&type=style&index=0&id=05f0c394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0c394",
  null
  
)

export default component.exports